import { render, staticRenderFns } from "./ChangeNpcAnswerEffect.vue?vue&type=template&id=6959eb05&scoped=true&"
import script from "./ChangeNpcAnswerEffect.vue?vue&type=script&lang=js&"
export * from "./ChangeNpcAnswerEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959eb05",
  null
  
)

export default component.exports